import React, { useCallback, useEffect, useState } from 'react';
import { IconContext } from 'react-icons';
import * as RiIcons from 'react-icons/ri';

import { useLocation } from '@reach/router';
import { Link } from 'gatsby';

import { useMixpanel } from '../../functions/Mixpanel';
import closeIcon from '../../images/closeIcon.svg';
import hamburgerMenuIcon from '../../images/hamburgerMenu.svg';

import { MainMenu } from './MenuItems';
import MobileDropdown from './MobileDropdown';
import * as style from './MobileNav.module.css';

const HamburgerMenu = ({ link, buttonTitle, openInNewTab }) => {
  const { mixpanel } = useMixpanel();
  const trackButton = useCallback(
    (button_name) => {
      mixpanel.track(button_name, {
        Section: 'Mobile Header',
      });
    },
    [mixpanel],
  );
  const [dropdown, setDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownShown, setDropdownShown] = useState('');
  const [submenuOpen, setSubmenuOpen] = useState([]);

  const menuToggleHandler = () => {
    setMenuOpen((p) => !p);
    setDropdown(!dropdown);
  };
  let itemsWithSubMenu = [];

  MainMenu.forEach((item) => {
    item.subMenu && itemsWithSubMenu.push(item);
  });

  const showDropdown = (title, position) => {
    setSubmenuOpen((currentMenu) => {
      currentMenu[position] = !currentMenu[position];

      return currentMenu;
    });
    if (dropdownShown === title) {
      setDropdownShown('');
    } else {
      setDropdownShown(title);
    }
  };

  const handleKeyDown = () => {
    showDropdown();
  };

  const url = useLocation();
  const [topLevelActive, setTopLevelActive] = useState([]);

  useEffect(() => {
    const NoOfItems = itemsWithSubMenu.length;
    setTopLevelActive(new Array(NoOfItems).fill(false));

    MainMenu.forEach((item) => {
      item.subMenu?.forEach((subItem) => {
        if (url.href?.includes(subItem.path)) {
          setTopLevelActive((currentTopLevel) => {
            currentTopLevel[item.position] = true;

            return currentTopLevel;
          });
        }
      });
    });
  }, [url.href, itemsWithSubMenu.length]);

  return (
    <IconContext.Provider value={{ color: '#070707' }}>
      <div className={style.hamburgerHeader}>
        <div className={style.hamburgerContainer}>
          <a
            href={link ? link : '/request-a-demo/'}
            target={openInNewTab ? '_blank' : undefined}
            rel="noreferrer"
          >
            <p className="button">
              {buttonTitle ? buttonTitle : 'Request Demo'}
            </p>
          </a>
        </div>
        <img
          src={!menuOpen ? hamburgerMenuIcon : closeIcon}
          onClick={menuToggleHandler}
          alt="close icon"
          onKeyDown={menuToggleHandler}
          role="presentation"
        />
      </div>
      {menuOpen && (
        <ul className={style.mobileDropdown}>
          {MainMenu.map((item, index) => {
            if (item.subMenu) {
              return (
                <div key={index}>
                  <li
                    key={index}
                    className={item.cName}
                    onClick={() => {
                      showDropdown(item.title, item.position);
                    }}
                    onKeyDown={handleKeyDown}
                    role="presentation"
                  >
                    <Link
                      className={
                        topLevelActive[index]
                          ? `${style.subMenu} ${style.active}`
                          : style.subMenu
                      }
                      activeClassName="active"
                    >
                      {item.title}
                      {submenuOpen[item.position] ? (
                        <RiIcons.RiArrowUpSLine size={24} />
                      ) : (
                        <RiIcons.RiArrowDownSLine size={24} />
                      )}
                    </Link>
                  </li>

                  {dropdownShown === item.title && (
                    <MobileDropdown
                      item={item}
                      key={index}
                      onClick={menuToggleHandler}
                    />
                  )}
                </div>
              );
            }

            return (
              <li key={index} className={item.cName}>
                <Link
                  activeClassName="active"
                  to={item.path}
                  onClick={menuToggleHandler}
                >
                  {item.title}
                </Link>
              </li>
            );
          })}
          <div className={style.requestDemoContainer}>
            <a
              href={link ? link : '/request-a-demo/'}
              className={style.requestDemo}
              onClick={() => trackButton({ buttonTitle })}
              target="_blank"
              rel="noreferrer"
            >
              {buttonTitle ? buttonTitle : 'Request a Demo'}
            </a>
          </div>
        </ul>
      )}
    </IconContext.Provider>
  );
};

export default HamburgerMenu;
